/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserProductSelectionsRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { mailClassSelected } from '../../../wizard/product-selector/redux/actions/ProductActions';
import DeleteModal from '../../../common/components/DeleteModal';
import Icons from '../../../../core/modules/common/components/Icons';
import { createProductPresetSelections, createProductPresetSelectionsOnSave } from '../../../react-table/helpers/utils';
import {
  saveGlobalSelectionProductRequestActionCreator,
  deleteGlobalSelectionProductRequestActionCreator, setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import Button from '../../../../core/modules/common/components/Button';
import WarningModal from '../../../common/components/WarningModal';
import EditProductSelectionModal from '../../../wizard/product-selector/containers/EditProductSelectionModal';
import SaveSelectionModal from '../components/SaveSelectionModal';

const mapStateToProps = state => ({
  selections: state.productSelector.selections,
  mailClassNodes: state.productSelector.mailClassNodes,
});

class AdminPresetProductHeaderBarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSelection: '',
      newPresetButtonDisabled: false,
      categories: [],
      name: '',
      showDeleteSelectionModal: false,
      showEditSelectionModal: false,
      showSaveSelectionModal: false,
      showOverwriteNewSelectionModal: false,
      showOverwriteSelectionModal: false,
      selections: [],
      categoriesUi: [],
      nameUi: '',
    };
  }

  componentDidMount() {
    this.props.fetchUserProductSelectionsRequestActionCreator();
  }

  componentDidUpdate(prevProps) {
    const { selections } = this.props;
    if (selections !== prevProps.selections) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        newSelection: selections,
      });
    }
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  // eslint-disable-next-line react/sort-comp
  applySelection = (e, { name, products }) => {
    const productSelectionsTransformed = createProductPresetSelections(products, this.props.mailClassNodes);
    productSelectionsTransformed.forEach(product => (
      this.props.mailClassSelected(
        product.mailCategoryCode,
        product.mailSubClasses,
        this.props.categoryOnlySelection,
      )));
    this.setState({
      activeSelection: name,
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      nameUi: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteGlobalSelectionProductRequestActionCreator(this.state.nameUi);
    this.onCloseModal();
  };

  openEditSelectionModal = (e, selection) => {
    e.stopPropagation();
    // eslint-disable-next-line react/prop-types
    const selections = createProductPresetSelectionsOnSave(this.props.categories, this.props.mailClassNodes);
    this.setState({
      showEditSelectionModal: true,
      selections: this.props.selections,
      categoriesUi: selections,
      nameUi: selection.name,
    });
  };

  editSelection = ({ name, categories }) => {
    // eslint-disable-next-line no-unused-vars
    const selections = createProductPresetSelectionsOnSave(this.props.categories, this.props.mailClassNodes);
    this.setState({
      name,
      categories,
    });
    if (name && name !== this.state.nameUi) {
      this.setState({
        showOverwriteNewSelectionModal: true,
        showOverwriteSelectionModal: false,
      });
    } else {
      this.setState({
        showOverwriteNewSelectionModal: false,
        showOverwriteSelectionModal: true,
      });
    }
    this.setState({
      newPresetButtonDisabled: false,
    });
    this.closeEditSelectionModal();
  };

  overwriteNewSelection = () => {
    this.props.saveGlobalSelectionProductRequestActionCreator(this.state.name, this.state.categories);
    this.props.setTabButtonStatus(false);
    this.onCloseNewOverwriteModal();
  };

  overwriteSelection = () => {
    this.props.saveGlobalSelectionProductRequestActionCreator(this.state.nameUi, this.state.categories);
    this.props.setTabButtonStatus(false);
    this.onCloseOverwriteModal();
  };

  closeEditSelectionModal = () => {
    this.setState({
      showEditSelectionModal: false,
    });
  };

  onCloseOverwriteModal = () => {
    this.setState({
      showOverwriteSelectionModal: false,
    });
  };

  onCloseNewOverwriteModal = () => {
    this.setState({
      showOverwriteNewSelectionModal: false,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name }) => {
    // const selections = createProductPresetSelectionsOnSave(this.props.productSelector.categories, this.props.productSelector.mailClassNodes);
    const newPreset = [...this.props.selections];
    newPreset.unshift({
      name,
      scope: 'GLOBAL',
      products: [
        { mailCategoryCode: '', mailSubClasses: [] },
        { mailCategoryCode: '', mailSubClasses: [] },
        { mailCategoryCode: '', mailSubClasses: [] },
        { mailCategoryCode: '', mailSubClasses: [] }],
    });
    this.setState({
      newSelection: newPreset,
      newPresetButtonDisabled: true,
    });
    this.closeSaveSelectionModal();
  };

  render() {
    // eslint-disable-next-line no-empty-pattern
    const {
    } = this.props;
    const {
      newSelection,
      newPresetButtonDisabled,
      showDeleteSelectionModal,
      showEditSelectionModal,
      showSaveSelectionModal,
      showOverwriteNewSelectionModal,
      showOverwriteSelectionModal,
    } = this.state;
    return (
      <div className="preset-div-admin">
        <Button
          className="headerbar-new-preset-button"
          text="app.selection.new.preset"
          onClick={() => this.openSaveSelectionModal()}
          disabled={newPresetButtonDisabled}
        />
        {newSelection && newSelection.length > 0 ? (
          <div className="product-selection-navigation">
            {showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
              }
            {showOverwriteSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.overwrite.operator.selection"
                onCloseModal={this.onCloseOverwriteModal}
                deleteSelection={this.overwriteSelection}
              />
              }
            {showOverwriteNewSelectionModal &&
              <WarningModal
                headerFormattedMessageId="app.warning.save.new.overwrite.operator.selection"
                onCloseModal={this.onCloseNewOverwriteModal}
                deleteSelection={this.overwriteNewSelection}
              />
              }
            {showEditSelectionModal &&
              <EditProductSelectionModal
                saveSelection={this.editSelection}
                closeModal={this.closeEditSelectionModal}
                selections={this.state.selections}
                categories={this.state.categoriesUi}
                name={this.state.nameUi}
              />
              }
            {showSaveSelectionModal &&
              <SaveSelectionModal
                saveSelection={this.saveSelection}
                closeModal={this.closeSaveSelectionModal}
                selections={this.props.selections}
                title="app.save.empty.new.preset"
              />
              }
            <ul className="presets">
              {
                newSelection
                    .filter(selection => selection.scope === 'GLOBAL' && selection.name !== 'Your last selection')
                    .map(selection =>
                      (
                        <li
                          key={selection.name}
                          onClick={e => this.applySelection(e, selection)}
                          className={`preset-wrapper ${this.state.activeSelection === selection.name ? 'active' : ''}`}
                        >
                          <div className="preset-pill">
                            <span>
                              {selection.name}
                            </span>
                            <button
                              className="delete-icon pill-name"
                              key={selection.name}
                              onClick={e => this.openDeleteSelectionModal(e, selection)}
                            >
                              <Icons.Custom name="trash-o" />
                            </button>
                            <button
                              className="global-icon-edit"
                              onClick={e => this.openEditSelectionModal(e, selection)}
                            >
                              <Icons.Custom name="save" />
                            </button>
                          </div>
                        </li>
                      ))
                }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserProductSelectionsRequestActionCreator,
  saveGlobalSelectionProductRequestActionCreator,
  deleteGlobalSelectionProductRequestActionCreator,
  mailClassSelected,
  setTabButtonStatus,
}, dispatch);

AdminPresetProductHeaderBarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({
      mailCategoryCode: PropTypes.string,
      mailSubClasses: PropTypes.arrayOf(PropTypes.string),
    })),
  })),
  fetchUserProductSelectionsRequestActionCreator: PropTypes.func,
  deleteGlobalSelectionProductRequestActionCreator: PropTypes.func,
  saveGlobalSelectionProductRequestActionCreator: PropTypes.func,
  mailClassSelected: PropTypes.func,
  categoryOnlySelection: PropTypes.bool,
  mailClassNodes: PropTypes.arrayOf(PropTypes.shape),
  setTabButtonStatus: PropTypes.func,
};

export const ConnectedAdminPresetProductHeaderBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminPresetProductHeaderBarContainer);

export default (ConnectedAdminPresetProductHeaderBarContainer);
